<mat-dialog-content>

    <div class="titleline">
    {{ confirmText | translate }}
    </div>

    <div class="line">
        <mat-radio-group [(ngModel)]="deleteOption" class="flex no-space-between">
            <mat-radio-button [value]="0">
                {{ 'Delete_only_selected_session' | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="1">
                {{ 'Delete_all_sessions_serie' | translate }}
            </mat-radio-button>
        </mat-radio-group>
    </div>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'Cancel' | translate }}</button>
    <button mat-raised-button (click)="onConfirmClicked()" color="{{ color }}">{{ confirmActionText | translate }}</button>
</mat-dialog-actions>
